import { makeStyles } from '@material-ui/core';
//import { pink } from '@material-ui/core/colors';

const useApplicantInfoStyles = makeStyles(() => ({
  about__company: {
    boxShadow: '0 0 10px rgba(0,0,0,.1)',
    padding: '36px',
    position: 'relative',
    '& .edit__button': {
      cursor: 'pointer',
      color: 'var(--teal-blue)',
      position: 'absolute',
      right: '35px',
      top: '35px',
    },
    '& .button__holder': {
      textAlign: 'right',
      '& button': {
        padding: '8px 10px',
        marginLeft: '10px',
        cursor: 'pointer',
        outline: 'none',
        border: 0,
        borderRadius: '5px',
      },
      '& .save__button': {
        backgroundColor: 'var(--teal-blue)',
        fontFamily: 'var(--font-family-bold)',
        color: 'var(--white)'
      },
      '& .cancel__button': {
        color: 'var(--teal-blue)',
        backgroundColor: 'transparent'
      }
    }
  },
  fontBold: {
    fontWeight: 600,
  },
  letsTalk:{
    '& .infoHeading':{
      fontSize: "40px",
      fontWeight: "700",
      paddingBottom: "10px"
    },
    '& .infoText':{
      width: "68%",
      paddingBlock: "9px",
      paddingBottom: "10px",
      fontWeight: "bold",
    },
    '& .listItems':{
      marginLeft: "20px"
    }

  }
}));

export default useApplicantInfoStyles;
